export default __webpack_public_path__ + "media/pins/map-pin-blue-hover@2x-cb18b07c.png";